var DesktopTziros = function() {
    return {
        refresh: function() {
            return Ajax.getTziro(
                DesktopTziros.date,
                $('#sort_selector option:selected').val() == 0,
                DesktopTziros.ticker,
                function(data) {
                    $('#live_tziros').html(data.html);
                    MatchesTable.applyAllFilters();
                    Generic.init_popovers();
                }
            );
        },
        refreshLoop: function() {
            DesktopTziros.refresh().finally(function() {
                setTimeout(DesktopTziros.refreshLoop, 60 * 1000);
            });
        },
        init: function(date, ticker) {
            DesktopTziros.date = date;
            DesktopTziros.ticker = ticker;
            setTimeout(DesktopTziros.refreshLoop, 60 * 1000);
            $('#sort_selector').change(function() {
                DesktopTziros.refresh();
            });
        }
    };
}();
